import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b99ad878"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "screen-nav"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 轮播 ")
const _hoisted_3 = {
  key: 1,
  class: "screen-nav"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (!_ctx.wallState.enabled)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.screens, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            key: item.path,
            to: item.path,
            class: _normalizeClass(["nav-item", { active: _ctx.route.path === item.path }])
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128)),
        _createVNode(_component_router_link, {
          to: "/wall",
          class: _normalizeClass(["nav-item wall", { active: _ctx.route.path === '/wall' }])
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["class"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("button", {
          class: "nav-item exit",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.exitWall && _ctx.exitWall(...args)))
        }, "退出轮播")
      ]))
}